<template>
  <div class="pagination_wrap">
    <el-pagination
      :page-size="pageSize"
      layout="prev, pager, next, total, jumper"
      :total="total"
      :pager-count="5"
      :current-page="page + 1"
      @current-change="handleCurrentChange"
      >
    </el-pagination>
    <div class="btn">确定</div>
  </div>
</template>

<script>
export default {
  props: {
    total: {
      type: Number,
      required: true
    },
    pageSize: {
      type: Number,
      default: 20
    },
    page: {
      type: Number,
      required: true
    }
  },
  methods: {
    handleCurrentChange (val) {
      this.$emit('update:page', val - 1)
    }
  }
}
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  .pagination_wrap
    height 60px
    display flex
    justify-content center
    align-items center
    .btn
      padding 5px 10px
      background $green_color
      margin-left 20px
      cursor pointer
</style>
